var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      placeholder: "Select employment type",
      value: _vm.mappedValue,
      multiple: false,
      options: _vm.employmentTypeOptions,
      customMultiStyleParent: [_vm.getParentStyle],
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }